import { render, staticRenderFns } from "./MyError.vue?vue&type=template&id=9b3bccae"
import script from "./MyError.vue?vue&type=script&lang=js"
export * from "./MyError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports